import React from 'react';
import styles from './FilterMonetize.module.css';

const filterMonetize = (props) => {
  const handleMonetizeChange = (e) => {
    props.setSelectedCategory({
      name: 'none',
      id: -1,
    });
    props.setSelectedMonetizeType(e.target.value);
  };

  return (
    <select id={styles['filter-monetize']} onChange={handleMonetizeChange}>
      <option
        value="paywall"
        selected={props.selectedMonetizeType === 'paywall'}
      >
        Paywall
      </option>
      <option value="tipjar" selected={props.selectedMonetizeType === 'tipjar'}>
        TipJar
      </option>
    </select>
  );
};

export default filterMonetize;
